module.exports = __webpack_public_path__ + "static/media/Finnovex-WA-2025.1a9d2bea.png";